import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'

let displayNameFilter;
export let numberFilter;
let officeDisplayNameFilter;
let costCenterDisplayNameFilter;
let groupDisplayNameFilter;

export function clearFilter() {
  displayNameFilter(null)
  numberFilter(null)
  officeDisplayNameFilter(null)
  costCenterDisplayNameFilter(null)
  groupDisplayNameFilter(null)
}

export const columns = [
  {
    dataField: 'checkBox',
    text: '',
    headerClasses: 'checkBox-header-cell',
    classes: 'checkBox-cell'
  },
  {
    dataField: 'displayName',
    text: 'name',
    sort: true,
    filterKey: 'filter.displayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { displayNameFilter = filter }} />
  },
  {
    dataField: 'number',
    text: 'assetPage:number',
    sort: true,
    filterKey: 'filter.number',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { numberFilter = filter }} />
  }, {
    dataField: 'office.displayName',
    text: 'orgaUnit',
    sort: true,
    filterKey: 'filter.officeDisplayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { officeDisplayNameFilter = filter }} />
  }, {
    dataField: 'costCenter.displayName',
    text: 'costcenter',
    sort: true,
    filterKey: 'filter.costCenterDisplayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { costCenterDisplayNameFilter = filter }} />,
    headerClasses: 'costcenter-header-cell',
    classes: 'costcenter-cell'
  },
  {
    dataField: 'group.displayName',
    text: 'assetPage:group',
    sort: true,
    filterKey: 'filter.groupDisplayName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { groupDisplayNameFilter = filter }} />,
    headerClasses: 'group-header-cell',
    classes: 'group-cell'
  },
  {
    dataField: 'actions',
    text: '',
    headerClasses: 'actions-header-cell',
    classes: 'actions-cell'
  }
];
